// @ts-strict-ignore
import { grid } from "@hubble/tokens/web";

export const createCallbackFunctionWithTimeout = (
  callback,
  opt_timeout = 1000
) => {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits#handling_timeouts
  let called = false;
  const fn = () => {
    if (!called) {
      called = true;
      callback();
    }
  };
  setTimeout(fn, opt_timeout);
  return fn;
};

export const shareSocial = (url) => {
  const left = (screen.width - 570) / 2;
  const top = (screen.height - 570) / 2;
  const params =
    "menubar=no,toolbar=no,status=no,width=570,height=570,top=" +
    top +
    ",left=" +
    left;
  window.open(url, "NewWindow", params);
};

/**
 * **Media Queries**
 *
 * Naving convention: `[device][breakpoint][Up|Down]`
 *
 * @example
 * ```ts
 * const Container = styled.div`
 *   @media ${mediaQuery.tabletSmUp} {
 *     color: hotpink;
 *   }
 * ';
 * ```
 */
export const mediaQuery = {
  mobileXsDown: `(max-width: ${grid.main.xs.maxWidth})`,
  tabletSmUp: `(min-width: ${grid.main.sm.minWidth})`,
  tabletSmDown: `(max-width: ${grid.main.sm.maxWidth})`,
  tabletMdUp: `(min-width: ${grid.main.md.minWidth})`,
  tabletMdDown: `(max-width: ${grid.main.md.maxWidth})`,
  desktopLgUp: `(min-width: ${grid.main.lg.minWidth})`,
  desktopLgDown: `(max-width: ${grid.main.lg.maxWidth})`,
  desktopXlUp: `(min-width: ${grid.main.xl.minWidth})`
} as const;

export const toggleClassNamesOnBodyTag = (bodyClassName: string) => {
  if (document.body.classList.contains(bodyClassName)) {
    document.body.classList.remove(bodyClassName);
  } else {
    document.body.classList.add(bodyClassName);
  }
};
